import WindowDefaults from './types/WindowDefaults';
import { isGulpOrBranching } from 'owa-querystring';
let options = (<WindowDefaults>(<unknown>window)).bootstrapOptions;

let overrideApp: string;
export function setApp(app: string) {
    overrideApp = app;
}

export function getApp() {
    return overrideApp || options.app;
}

export function getClientVersion() {
    return options ? options.scriptVer : '';
}
export function getCacheType() {
    return options.cacheType;
}

export function getCacheExpiryTime() {
    return options.cacheExpiryTime;
}

let overridePackageBaseUrl: string;
let overrideScriptRelative: string;
let overrideBackupBase: string;
export function setUrls(packageBase: string, backupBase: string, scriptRelative: string) {
    overridePackageBaseUrl = packageBase;
    overrideBackupBase = backupBase;
    overrideScriptRelative = scriptRelative;
}

function addVersionToPath(base: string): string {
    const version = isGulpOrBranching() ? '' : getClientVersion() + '/';
    return base + version;
}

export function getPackageBaseUrl(): string {
    return overridePackageBaseUrl
        ? addVersionToPath(overridePackageBaseUrl)
        : options.packageBaseUrl;
}

function getScriptRelativePath(): string {
    return typeof overrideScriptRelative !== 'undefined'
        ? overrideScriptRelative
        : options.scriptPath;
}

export function getScriptPath(): string {
    return getPackageBaseUrl() + getScriptRelativePath();
}

export function getScriptBackupPath(): string {
    return (
        (overrideBackupBase ? addVersionToPath(overrideBackupBase) : options.backupBaseUrl) +
        getScriptRelativePath()
    );
}

export function test_setOptions(testOptions: any) {
    options = testOptions;
}
